import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f30189b")

_pushScopeId("data-v-5f30189b")
const _hoisted_1 = { class: "fridgeDetailsconfirmsettingsdialog-item" }
const _hoisted_2 = { class: "fridgeDetailsconfirmsettingsdialog-item-name" }
const _hoisted_3 = { class: "fridgeDetailsconfirmsettingsdialog-item-name-text" }
const _hoisted_4 = { class: "fridgeDetailsconfirmsettingsdialog-item-value" }
const _hoisted_5 = { class: "fridgeDetailsconfirmsettingsdialog-item-value-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.itemName), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.itemValue), 1)
    ])
  ]))
})